import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Repas {
  id: number;
  name: string;
  date: string;
  nameCateg: string;
  idCateg: number;
}

export interface CantineType {
  type: string;
  list: Repas[];
}

export interface CantineJour {
  jour: string;
  date: string;
  cantine: CantineType[];
}

export interface MenuImage {
  error: string;
  response: {
    id: number;
    path: string;           // URL de l'image
    arName: string;         // Nom en arabe
    description: string;
    dateDebut: string;
    dateFin: string;
    active: number;
    creationDate: string;
    updateDate: string;
    errorMsg: string;
    errorId: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class CantineService {
  private apiBaseUrl = environment.apiUrl.replace(/\/$/, '');
  private baseUrl = `${this.apiBaseUrl}/studentExterneCantine/`;

  constructor(private http: HttpClient) {}

  // 🔹 Récupérer le menu avec image par organisation
  getMenuWithImage(idOrganization: number): Observable<MenuImage> {
    const url = `${this.apiBaseUrl}/cantine/afficheMenu/${idOrganization}`;
    return this.http.get<MenuImage>(url);
  }

  // 🔹 Récupérer la configuration de l'organisation pour emploi/cantine
  // Endpoint: /api/organization/configurationEmploiCantine/{idOrganization}
  getOrganizationConfiguration(idOrganization: number): Observable<any> {
    const url = `${this.apiBaseUrl}/organization/configurationEmploiCantine/${idOrganization}`;
    return this.http.get<any>(url);
  }

  // 🔹 Récupérer les repas par étudiant (ancienne API)
getCantineByStudent(
  idOrg: number,
  userId: number,
  idStudent: number,
  batchId: number
): Observable<CantineJour[]> {
  const url = `${this.apiBaseUrl}/cantine/listCantineStudent/${idOrg}/${userId}/${idStudent}/${batchId}`;
  return this.http.get<CantineJour[]>(url);
}


  // 🔹 Nouvelle API : Rechercher les réservations
  searchCantine(payload: {
    idStudent: number;
    type: string;
    beginDate: string;
    endDate: string;
  }): Observable<any> {
    const url = `${this.baseUrl}search`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(url, payload, { headers });
  }

  // 🔹 Nouvelle API : Réserver avec dates et type
  reserverCantine(payload: {
    idstudent: string;
    dateDebut: string;
    dateFin: string;
    idreservation: string;
    orgid: string;
    type: string;
  }): Observable<any> {
    const url = `${this.baseUrl}reservationwithDatesAndType`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(url, payload, { headers });
  }

  // 🔹 Supprimer une réservation (ancienne API)
// Ancienne méthode POST remplacée par DELETE
supprimerReservation(idreservation: number): Observable<any> {
  const url = `${this.apiBaseUrl}/studentExterneCantine/delete/${idreservation}`;
  return this.http.get(url); // ⚠️ utiliser GET car l'API attend GET
}


  searchReservations(payload: {
    idStudent: number;
    type: string;
    beginDate: string;
    endDate: string;
  }): Observable<any> {
    const url = `${this.baseUrl}/search`;
    return this.http.post(url, payload);
  }
  getReservationsByStudent(
    idstudent: number,
    typeres: string,
    dateDebut: string,
    dateFin: string
  ): Observable<any> {
    const url = `https://mon-compte.educanet.pro/mobile/cantine/GetStudentExterneCantineByStudentAndDates/${idstudent}/${typeres}/${dateDebut}/${dateFin}`;
    return this.http.get(url);
  }
}
